import Vue from 'vue'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

Vue.use(Toast, {
  // see for configuration: https://vue-toastification.maronato.dev/
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true,
  filterToasts: (toasts) => {
    // remove duplicate messages
    const uniqueToasts = []
    const uniqueMessages = new Set()
    toasts.forEach((toast) => {
      if (!uniqueMessages.has(toast.content)) {
        uniqueToasts.push(toast)
        uniqueMessages.add(toast.content)
      }
    })
    return uniqueToasts
  },
})
